import _extends from "@babel/runtime-corejs2/helpers/extends";
import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tag from '@alifd/next/lib/tag';
import ColoredTag from './Colored';
import { Color, COLORED_GROUP_CLASS_NAME, PROTECTED_TYPE } from './constants';
var TagGroup = Tag.Group;
var defaultAvaliableColors = [Color.LIGHT_STEEL_BLUE, Color.PLUM, Color.MISTY_ROSE, Color.LIGHT_GOLDENROD_YELLOW, Color.PALE_GREEN];

var ColoredGroup = function ColoredGroup(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$avaliableColors = _ref.avaliableColors,
      avaliableColors = _ref$avaliableColors === void 0 ? defaultAvaliableColors : _ref$avaliableColors,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(TagGroup, {
    className: classNames(COLORED_GROUP_CLASS_NAME, className),
    style: style
  }, Children.map(children, function (elem, i) {
    var hijackedElem = elem;

    try {
      var protectedElemType = elem.type[PROTECTED_TYPE];

      if (protectedElemType === 'Tag') {
        hijackedElem = /*#__PURE__*/React.createElement(ColoredTag, _extends({}, elem.props, {
          type: avaliableColors[i % 5]
        }));
      }
    } catch (err) {
      /** DO NOT thrown unexpected error but swallow it */
    }

    return hijackedElem;
  }));
};

ColoredGroup.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  avaliableColors: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node
};
export default ColoredGroup;